// A user's single role in an organization, shared by the role chip on each
// member row (roles/OrgRoles.vue) and the role filter above the member list
// (OrganizationUserList.vue).

import { OrgRole } from '@/models';
import { OrgUser } from '@/models/orgStructure';

export type OrgRoleFilter = OrgRole | 'ALL';

/**
 * The role a user holds in the organization, or null for an orphan: someone
 * connected to the org's groups who isn't an org member, and so holds no org
 * role at all.  Admin outranks organizer when both flags are set.
 */
export const orgRoleOf = (
  user: Pick<OrgUser, 'isOrphan' | 'isAdmin' | 'isOrganizer'>
): OrgRole | null => {
  if (user.isOrphan) {
    return null;
  }

  if (user.isAdmin) {
    return OrgRole.ADMIN;
  }

  if (user.isOrganizer) {
    return OrgRole.ORGANIZER;
  }

  return OrgRole.MEMBER;
};
